import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CaretLeft, Coffee } from 'phosphor-react';
import { DynamicFlapperLogo } from '../components';
import '../styles/design-system.css';
import '../styles/UpgradePage.css';
import { SUPPORT_URL } from '../config/support';

function UpgradePage() {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="upgrade-page support-page">
      <div className="page-header">
        <button className="back-button" onClick={handleBackClick}>
          <CaretLeft size={24} weight="bold" />
        </button>
        <h1 className="page-title">Support What's The Score?</h1>
        <div className="header-spacer"></div>
      </div>

      <div className="page-content support-content">
        <div className="support-hero">
          <DynamicFlapperLogo matches={[]} size="large" showTooltip={false} />
        </div>

        <div className="support-card">
          <p className="support-body">
            What's The Score? exists because scoreboards are hard to see and parents keep asking, "What's the score?" Now you can stay put and still follow the game.
          </p>
          <p className="support-body">
            If it makes tournament days easier and you enjoy this app, you can buy me a coffee :)
          </p>
        </div>

        <a
          className="support-button support-primary-button"
          href={SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Coffee size={18} weight="fill" />
          Buy me a coffee
        </a>

        <p className="support-footnote">
          Right now everyone has full access. Your support keeps What’s The Score? running and evolving.
        </p>
      </div>
    </div>
  );
}

export default UpgradePage;
